import moment from 'moment';

export default function formatDateToISO(dateString: string | Date): string {
  return moment(new Date(dateString)).format('YYYY-MM-DDTHH:mm:ss');
}